.icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
